import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from "@services/backend/user.service";
import { UserProfile } from '@interfaces/user-profile.interface';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	app: string = environment.APP;
	currentLang: any = localStorage.getItem('currentLang');
	userImg: any;

	constructor(private userService: UserService,
		public translate: TranslateService) {
	}
  
  changeLanguage(event: any) {
		this.translate.use(event.target.value)
		localStorage.setItem('currentLang', event.target.value);
	}

  ngOnInit(): void {
		this.userService.userProfile$.subscribe((profile: UserProfile) => {
			if (profile?.image?.url) {
				this.userImg = profile.image.url
			}
		});
	}
}
